import {computed, observable, action} from 'mobx';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'shared/core';
import {PerformanceReviewReview} from 'stores/performance_reviews';
import Employee from 'stores/employees/Employee';
import _ from 'lodash';
import {PerformanceReviewReviewee} from 'stores/performance_reviews';

class RevieweeResultsState {
  store = new DomainStore();
  match;

  @observable reviews = [];
  @observable revieweeEmployee;
  @observable reviewee;
  @observable reviewAnswerRefs = [];

  receiveProps({match}) {
    this.match = match;
  }

  @action async load() {
    const {params} = this.match;
    await this.store._compose(endpoints.PERFORMANCE_REVIEWS.REVIEWEE.with(params.cycleId, params.revieweeId));

    this.reviews = this.store._getAll(types.PERFORMANCE_REVIEWS.REVIEW, PerformanceReviewReview);
    this.revieweeEmployee = new Employee(this.store._getSingle(types.EMPLOYEE, { id: params.employeeId }));
    this.reviewee = new PerformanceReviewReviewee(this.store._getSingle(types.PERFORMANCE_REVIEWS.REVIEWEE, { employee: { id: params.employeeId } }));
  }

  @computed get cycleBackPaths() {
    return ['team', 'admin'];
  }

  @action getBackButtonDetails(params) {
    const BASE_PATH = `/reviews/${params.cycleId}`;
    const BASE_TITLE = 'performance_reviews.view.back_paths';
    const CYCLE_BACKPATH = _.includes(this.cycleBackPaths, params.backPath);
    const REVIEWEE_BACKPATH = 'reviewees' === params.backPath;

    if (CYCLE_BACKPATH) {
      return {
        backPath: `${BASE_PATH}/${params.backPath}`,
        backTitle: `${BASE_TITLE}.${params.backPath}`
      };
    } else if (REVIEWEE_BACKPATH) {
      return {
        backPath: `/${params.backPath}`,
        backTitle: `${BASE_TITLE}.${params.backPath}`
      };
    } else {
      return {
        backPath: `${BASE_PATH}/`,
        backTitle: `${BASE_TITLE}.back`
      };
    }
  }

  @computed get hasReviews() {
    if (_.isEmpty(this.reviews)) return false;

    return !_.isEmpty(this.reviewsWithAnswers);
  }

  @computed get reviewsWithAnswers() {
    return _.filter(this.reviews, (review) => {
      return !_.isEmpty(review.answers) && review.submitted;
    });
  }

  @computed get sortedReviews() {
    const reviewsWithoutAnswers = _.differenceBy(
      this.reviewee.reviews,
      this.reviewsWithAnswers,
      'id'
    );

    return [...this.reviewsWithAnswers, ...reviewsWithoutAnswers];
  }

  @computed get reviewersWithStatus() {
    const reviewers = _.map(this.sortedReviews, review => {
      return {
        reviewer: review.reviewer,
        status: review.submitted
      };
    });

    return reviewers;
  }

  scrollToReview(model) {
    const review = _.find(this.reviewsWithAnswers, review => review.reviewer.id === model.reviewer.id);

    if (!review) return;
    const ref = _.find(this.reviewAnswerRefs, ref => ref.id === review.id);

    if (ref) ref.element.scrollIntoView({behavior: 'smooth'});
  }

  addRef(ref) {
    if (!ref) return;

    const elementWithId = {
      id: ref.id,
      element: ref
    };

    this.reviewAnswerRefs.push(elementWithId);
  }
}

export default RevieweeResultsState;
